





















































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { ChatService } from '@/services/chat/index';
import { ChatModule } from '@/store/modules/chat/chat.store';
import { ChatMember, GroupChatViewObject } from '@/types/apiServerContract';
import { ModalConstants } from '@/core/constants';

import EditGroupChat from '@/components/frontpage/chat/EditGroupChat.vue';
import GroupChatMember from '@/components/frontpage/chat/GroupChatMember.vue';
import GroupChatSearch from '@/components/frontpage/chat/GroupChatSearch.vue';
import GroupChatMessageBoard from '@/components/frontpage/chat/GroupChatMessageBoard.vue';
import urlHelperService from '@/services/url/urlHelper.service';

@Component({
    components: {
        EditGroupChat,
        GroupChatMember,
        GroupChatSearch,
        GroupChatMessageBoard
    }
})
export default class Chat extends Vue {
	@Prop({ type: Boolean }) isLoggedIn!: boolean;

	loaded: boolean = false;
	term: string = '';

	get activeChat() {
	    return ChatModule.activeChat;
	}

	async setActiveChat(chat: GroupChatViewObject) {
	    if (ChatModule.activeChat?.id === chat.id) {
	        return;
	    }

	    ChatModule.SetActiveChat(chat);
	    if (chat.unreadMessageCount > 0) {
	        ChatModule.MarkMessagesAsRead(chat.id);
	    }

	    urlHelperService.setQueryParam('chat', chat.id);
	}

	getOnlineCount(members: ChatMember[]) {
	    return members.filter(x => x.online).length;
	}

	getOfflineCount(members: ChatMember[]) {
	    return members.filter(x => !x.online).length;
	}

	get groupChats() {
	    const chats = [...ChatModule.activeChats];
	    const term = this.term.toLowerCase();
	    return this.term.length > 0
	        ? chats.filter(x => x.name.toLowerCase().includes(term) || x.members.some(m => m.authorName.toLowerCase().includes(term)))
	        : chats;
	}

	getMembersForChat(chat: GroupChatViewObject) {
	    return chat.members.filter(x => x.author !== this.$user.id);
	}

	isChatOwner(chat: GroupChatViewObject) {
	    return chat.owner === this.$user.id;
	}

	async getGroupChats() {
	    try {
	        await ChatModule.GetGroupChats();
	        if (this.groupChats.length > 0) {
	            const activeChat = urlHelperService.getQueryParam('chat');
	            if (activeChat) {
	                const chat = this.groupChats.find(x => x.id === activeChat);
	                if (chat) {
	                    this.setActiveChat(chat);
	                } else {
	                    this.setActiveChat(this.groupChats[0]);
	                }
	            } else {
	                this.setActiveChat(this.groupChats[0]);
	            }
	        }
	    } finally {
	        this.loaded = true;
	    }
	}

	async leaveChat(chat: GroupChatViewObject) {
	    const check = await this.$bvModal.msgBoxConfirm('Are you sure you wish leave this chat?', {
	        centered: true,
	        okTitle: 'Yes'
	    });
	    if (!check) return;

	    await ChatModule.LeaveGroupChat(chat.id);
	}

	editGroupChat() {
	    this.$bvModal.show(ModalConstants.EditGroupChat);
	}

	async created() {
	    await ChatService.start();
	    this.getGroupChats();
	}

	beforeDestroy() {
	    ChatModule.Reset();
	    ChatService.stop();
	}
}
